/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AIReviewBatchItem } from './AIReviewBatchItem';
export type AIReviewBatchRequest = {
  action: AIReviewBatchRequest.action;
  items: Array<AIReviewBatchItem>;
  /**
   * Optional reviewer note stamped as review_reason on the field entries an accept or decline settles. Citations, mappings and reopen ignore it.
   */
  reason?: string | null;
};
export namespace AIReviewBatchRequest {
  export enum action {
    ACCEPT = 'accept',
    DECLINE = 'decline',
    REOPEN = 'reopen',
  }
}

